import type { BusinessProfileLinkResponse, BusinessProfileLinksResponse } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const profileLinksApi = {
  async list(businessId: string): Promise<BusinessProfileLinksResponse> {
    const res = await api.api.businesses[':businessId']['profile-links'].$get({
      param: { businessId },
    })
    return unwrap<BusinessProfileLinksResponse>(res)
  },

  async link(businessId: string, code: string): Promise<BusinessProfileLinkResponse> {
    const res = await api.api.businesses[':businessId']['profile-links'].$post({
      param: { businessId },
      json: { code },
    })
    return unwrap<BusinessProfileLinkResponse>(res)
  },

  async unlink(businessId: string, userProfileId: string): Promise<void> {
    const res = await api.api.businesses[':businessId']['profile-links'][':userProfileId'].$delete({
      param: { businessId, userProfileId },
    })
    await unwrap<void>(res)
  },
}
